export function isWallItem(item) {
    return 'ownerUserId' in item;
}
export function isUserWallItem(item) {
    return !('ownerUserId' in item);
}
//# sourceMappingURL=guards.js.map